var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84443 5L9.91172 0.93271C10.0294 0.815003 10.0294 0.624382 9.91172 0.506675L9.49333 0.0882797C9.37562 -0.0294266 9.185 -0.0294266 9.06729 0.0882797L5 4.15557L0.93271 0.0882797C0.815003 -0.0294266 0.624382 -0.0294266 0.506675 0.0882797L0.0882797 0.506675C-0.0294266 0.624382 -0.0294266 0.815003 0.0882797 0.93271L4.15557 5L0.0882797 9.06729C-0.0294266 9.185 -0.0294266 9.37562 0.0882797 9.49333L0.506675 9.91172C0.624382 10.0294 0.815003 10.0294 0.93271 9.91172L5 5.84443L9.06729 9.91172C9.185 10.0294 9.37562 10.0294 9.49333 9.91172L9.91172 9.49333C10.0294 9.37562 10.0294 9.185 9.91172 9.06729L5.84443 5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/XIcon.772172a9eb113a3e63c9abc61f4e2f69.svg";
export { ForwardRef as ReactComponent };